import React from 'react';
import { Box, Typography, Grid, Button, Container } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ProductCardEnhanced from './ProductCardEnhanced';
import type { Product } from '../../services/types';

interface FeaturedSectionProps {
  title: string;
  products: Product[];
  onAddToCart: (product: Product) => void;
  onToggleFavorite: (product: Product) => void;
  isInWishlist: (id: string | number) => boolean;
  onQuickView: (product: Product) => void;
  viewAllLink?: string;
  bgColor?: string;
}

const FeaturedSection: React.FC<FeaturedSectionProps> = ({
  title,
  products,
  onAddToCart,
  onToggleFavorite,
  isInWishlist,
  onQuickView,
  viewAllLink,
  bgColor = 'transparent',
}) => {
  if (products.length === 0) return null;

  return (
    <Box sx={{ py: 6, bgcolor: bgColor }}>
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h2" fontWeight="bold">
            {title}
          </Typography>
          {viewAllLink && (
            <Button endIcon={<ArrowForward />} color="primary">
              View All
            </Button>
          )}
        </Box>

        <Grid container spacing={3} alignItems="stretch">
          {products.slice(0, 4).map((product) => (
            <Grid key={product.id} item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
              <ProductCardEnhanced
                product={product}
                onAddToCart={onAddToCart}
                onToggleFavorite={() => onToggleFavorite(product)}
                isFavorite={isInWishlist(product.id)}
                onQuickView={onQuickView}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturedSection;
